import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Refresh } from '@mui/icons-material';
import Loading from '../../common/loading';
import { getBankAccounts, showBankAccount } from '../../../store/bank-accounts/actions';
import Table from '../../common/table';
import icBank from '../../../assets/icons/bank.svg';
import { Urls } from '../../../config/urls';
import l from '../../../lang';
import './styles.scss';
import MessageError from '../../common/message-error';
import TopDashboardSection from '../../common/top-dashboard-section';
import Dialog from '../../common/dialog';
import BankAccountDetail from './bank-account-detail';
import ButtonMore from '../../common/button-more';
import AddNewBankAccount from './add-bank-account-forms/add-bank-account';
import AccordionLeft from '../../common/accordion-left';
import { useHistory } from 'react-router-dom';
import { Routes } from '../../../config/routes';
import ButtonLink from '../../common/button-link';

const BankAccounts = ({
  loading,
  error,
  allBankAccounts,
  newBankAccountSuccess,
  showBankAccount,
  fnShowBankAccount,
  fnGetBankAccounts,
  country,
  currentKYC,
  validKYC,
}) => {
  const [bankAccountDetail, setBankAccountDetail] = useState(null);
  const history = useHistory();

  useEffect(() => {
    fnGetBankAccounts();
  }, [fnGetBankAccounts]);

  useEffect(() => {
    if (newBankAccountSuccess) {
      fnShowBankAccount(false);
      fnGetBankAccounts();
    }
  }, [newBankAccountSuccess, fnShowBankAccount, fnGetBankAccounts]);

  const dataExist = allBankAccounts?.data?.length > 0;

  return (
    <>
      <TopDashboardSection title={l('menu.item.BANK_ACCOUNTS')} subtitle={l('menu.item.BANK_ACCOUNTS.desc')} />
      <div className={`panel ${dataExist && !loading ? 'panel--no-bg' : ''} bank-accounts`}>
        <div className={`bank-accounts__container ${dataExist ? 'bank-accounts__container--data-exist' : ''}`}>
          {loading && (
            <div className="bank-accounts__loading">
              <Loading />
            </div>
          )}
          {error && (
            <div className="bank-accounts__error">
              <MessageError iconClose={<Refresh />} onClose={() => fnGetBankAccounts()} />
            </div>
          )}
          {!loading && !error && (
            <div className="bank-accounts__table">
              <Table
                idxHiddenColumnsOnMobile={[0, 1, 2, 3]}
                withBtnMenu
                maxHeight="280px"
                headers={[
                  l('bankAccounts.country'),
                  l('bankAccounts.name'),
                  l('bankAccounts.documentType'),
                  l('bankAccounts.document'),
                  l('bankAccounts.bankName'),
                  country === 'ES' ? l('bankAccounts.IBAN') : l('bankAccounts.bankAccount'),
                ]}
                body={
                  (dataExist &&
                    allBankAccounts?.data?.map(account => {
                      const item = [
                        <img
                          alt={`img-country-${account.country}`}
                          className="bank-accounts__country"
                          src={Urls.flags.replace(':code', account.country)}
                        />,
                        <span>{`${account.beneficiaryFirstName || ''} ${account.beneficiaryLastName || ''}`.trim()}</span>,
                        <span>{account.beneficiaryDocumentType}</span>,
                        <span>{account.beneficiaryDocument}</span>,
                        <span>{account.bankName}</span>,
                        <span>{account.bankAccount}</span>,
                        <ButtonMore onClick={() => setBankAccountDetail(account)} />,
                      ];
                      return item;
                    })) ||
                  null
                }
              />
              {bankAccountDetail && (
                <Dialog
                  dividers={false}
                  unpaddingFooter
                  unpaddingContent
                  fullScreenMobile
                  titleCenter
                  title={l('bankAccounts.details')}
                  handleClose={() => setBankAccountDetail(null)}
                  body={<BankAccountDetail detail={bankAccountDetail} />}
                />
              )}
              {!dataExist && (
                <div className="bank-accounts__no-accounts">
                  <div>
                    <img className="bank-accounts__no-accounts__img" src={icBank} alt="img-no-accounts" />
                    {(currentKYC < 4 || (currentKYC === 4 && !validKYC)) && (
                      <div>
                        {l('bankAccounts.noAccounts')}
                        <ButtonLink
                          text={l('bankAccounts.noAccounts.link')}
                          onClick={() => history.push(Routes.COMPANY_INFORMATION)}
                        />
                        {l('bankAccounts.noAccounts2')}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {(dataExist || (currentKYC === 4 && validKYC)) && (
        <div className="panel bank-accounts__new-bank-account">
          <AccordionLeft
            open={showBankAccount}
            title={l('bankAccounts.addBankAccount')}
            onClick={() => fnShowBankAccount(!showBankAccount)}
            body={<AddNewBankAccount />}
          />
        </div>
      )}
    </>
  );
};

BankAccounts.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.bool,
  allBankAccounts: PropTypes.object,
  newBankAccountSuccess: PropTypes.bool,
  showBankAccount: PropTypes.bool,
  fnShowBankAccount: PropTypes.func,
  fnGetBankAccounts: PropTypes.func,
};

const mapStateToProps = state => ({
  loading: state.bankAccounts.loading,
  error: state.bankAccounts.error,
  allBankAccounts: state.bankAccounts.allBankAccounts,
  newBankAccountSuccess: state.bankAccounts.newBankAccount.success,
  showBankAccount: state.bankAccounts.newBankAccount.show,
  country: state.dashboard.merchantMe?.country,
  currentKYC: state.dashboard.merchantMe?.kycLevel.level,
  validKYC: state.dashboard.merchantMe?.validKYC,
});

const mapDispatchToProps = dispatch => ({
  fnShowBankAccount: show => dispatch(showBankAccount(show)),
  fnGetBankAccounts: () => dispatch(getBankAccounts()),
});

export default connect(mapStateToProps, mapDispatchToProps)(BankAccounts);
